import React, { useRef, useState } from 'react';

import chevronDownSmallTokens from '@amzn/meridian-tokens/base/icon/chevron-down-small';
import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import Menu, { MenuItem } from '@amzn/meridian/menu';
import {
  APPROVED_TWP,
  ASSOCIATE_DECISION_PENDING,
  DENIED_TWP,
  INDEFINITE_RESTRICTIONS,
  PLACEMENT_DECISION_PENDING,
  TWP_BUT_PENDING_UPDATED_RESTRICTIONS,
} from 'src/config/AccommodationStatusNames';
import type { AssociateProfilePlacement } from 'src/services/associateProfile/types';

interface ActionsProps {
  placement: AssociateProfilePlacement;
}
const UpdateActionMenu = ({ placement }: ActionsProps) => {
  const updateLinkRef = useRef();
  const [updateMenuOpen, setUpdateMenuOpen] = useState(false);
  const onClickButton = () => setUpdateMenuOpen(true);
  const onClose = () => setUpdateMenuOpen(false);

  const placementSelectionStatuses = [
    PLACEMENT_DECISION_PENDING,
    ASSOCIATE_DECISION_PENDING,
    APPROVED_TWP,
    INDEFINITE_RESTRICTIONS,
    TWP_BUT_PENDING_UPDATED_RESTRICTIONS,
    DENIED_TWP,
  ];

  return (
    <>
      <Button type="link" ref={updateLinkRef} onClick={onClickButton}>
        Update <Icon tokens={chevronDownSmallTokens} />
      </Button>
      <Menu
        anchorNode={updateLinkRef.current}
        id="update-menu"
        open={updateMenuOpen}
        position="bottom"
        onClose={onClose}
        minWidth="200px"
      >
        <MenuItem onClick={() => console.info('Restriction Dates')}>Restriction Dates</MenuItem>
        <MenuItem onClick={() => console.info('Restrictions')}>Restrictions</MenuItem>
        {placement.accommodationType === 'AUSTIN' && (
          <MenuItem onClick={() => console.info('Initiate Transfer')}>Initiate Transfer</MenuItem>
        )}
        {placementSelectionStatuses.includes(placement.accommodationStatus) && (
          <MenuItem onClick={() => console.info('Placement Selection(s)')}>Placement Selection(s)</MenuItem>
        )}
      </Menu>
    </>
  );
};

export default UpdateActionMenu;
